
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

@Component
export default class TimePicker extends Vue {
	@Prop({ default: "" }) private selectedTime!: string; // e.g. '13:45:30' or any parseable time
	@Prop({ default: "Time" }) private label!: string;

	private timePickerOpen: boolean = false;
	private internalTime: string = "";

	private mounted() {
		this.setTime();
	}

	@Watch("selectedTime")
	private onSelectedTimeChanged() {
		this.setTime();
	}

	private setTime() {
		// Try to parse; if invalid, leave empty
		const m = moment(this.selectedTime, ["HH:mm:ss", "HH:mm", moment.ISO_8601], true);
		this.internalTime = m.isValid() ? m.format("HH:mm:ss") : "";
	}

	private get selectedTimeFormatted() {
		// If you want locale-specific display, you could format differently here
		// For now we show HH:mm:ss to match what's emitted
		return this.internalTime || "";
	}

	private timeChanged(val: string) {
		// v-time-picker provides the string (HH:mm[:ss]) as val
		// Normalize to HH:mm:ss
		const normalized = moment(val, ["HH:mm:ss", "HH:mm"]).format("HH:mm:ss");
		this.internalTime = normalized;
		this.$emit("update:selectedTime", normalized);
		this.timePickerOpen = false;
	}
}
